/* 🤖 this file was generated by svg-to-ts */
export var spxIconClock01 = {
    name: 'clock_01',
    data: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g transform=\"translate(1.25 1.25)\"><g><circle cx=\"10.75\" cy=\"10.75\" r=\"10\" stroke-width=\"1.5\"/><path d=\"M10.75 6.75V10.75L12.75 12.75\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></g></g></svg>"
};
